import React from 'react';
import { Link } from 'react-router-dom';
import { FaLinkedinIn, FaXTwitter, FaGithub } from 'react-icons/fa6';

const Footer = () => {
  return (
    <footer>
      <div className="container">
        <div className="footer-content">
          <div className="footer-section">
            <div className="footer-logo">
              <img
                src="/DISENAILOGOmain.png"
                alt="Disen Systems"
                className="footer-logo-img"
              />
            </div>
            <p className="footer-desc">
              Disen Systems enables secure GenAI and machine learning adoption—modernizing data platforms, deploying copilots, and governing models at scale.
            </p>
            <div className="social-links">
              <a href="#" title="LinkedIn"><FaLinkedinIn /></a>
              <a href="#" title="Twitter"><FaXTwitter /></a>
              <a href="#" title="GitHub"><FaGithub /></a>
            </div>
          </div>
          <div className="footer-section">
            <h3 style={{ color: 'var(--amber-light)' }}>Solutions</h3>
            <ul>
              <li><Link to="/solutions">AI Strategy & Readiness</Link></li>
              <li><Link to="/solutions">Data Platform Modernization</Link></li>
              <li><Link to="/solutions">GenAI / RAG Applications</Link></li>
              <li><Link to="/solutions">LLM Evaluation</Link></li>
              <li><Link to="/solutions">MLOps & Governance</Link></li>
            </ul>
          </div>
          <div className="footer-section">
            <h3>Company</h3>
            <ul>
              <li><Link to="/about">About Us</Link></li>
              <li><Link to="/case-studies">Case Studies</Link></li>
              <li><Link to="/industries">Industries</Link></li>
              <li><Link to="/insights">Insights</Link></li>
              <li><Link to="/contact">Contact</Link></li>
            </ul>
          </div>
          <div className="footer-section">
            <h3 style={{ color: 'var(--violet-light)' }}>Resources</h3>
            <ul>
              <li><a href="#">Documentation</a></li>
              <li><a href="#">API Reference</a></li>
              <li><a href="#">Blog</a></li>
              <li><a href="#">Privacy Policy</a></li>
              <li><a href="#">Terms of Service</a></li>
            </ul>
          </div>
        </div>
        <div className="footer-bottom">
          <p>&copy; 2026 Disen Systems. All rights reserved.</p>
          <div className="footer-links">
            <a href="#">Privacy Policy</a>
            <a href="#">Terms of Service</a>
            <a href="#">Cookie Policy</a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
